// import { withOverlayControls } from '@eventbrite/eds-structure';
import { defineMessages } from 'react-intl';
import {
    getLocationSuggestions,
    LocationAutocomplete,
} from '@eventbrite/consumer-search.location-autocomplete';
import memoize from 'lodash/memoize';
import { connect } from 'react-redux';
import {
    getUserCurrentLocation as getUserCurrentLocationAction,
    locationChange as locationChangeAction,
    searchLocationSuggestions as searchLocationSuggestionsAction,
} from '@/redux/location';
import { messageDescriptorToString } from '@/utils/messageDescriptor';

const messages = defineMessages({
    onlineEvents: {
        id: 'Online events',
        defaultMessage: 'Online events',
    },
    chooseLocation: {
        id: 'Choose a location',
        defaultMessage: 'Choose a location',
    },
});

const getLocationSuggestionsMemoized = memoize(getLocationSuggestions);

interface HomeLocationAutoCompleteContainerProps {
    location: {
        isOnline?: boolean;
        currentPlace?: string;
        currentPlaceParent?: string;
        isUsingCurrentLocation?: boolean;
        locationDenied?: boolean;
        isWaitingForLocation?: boolean;
        latitude?: number;
        longitude?: number;
        placeId?: string;
    };
}

const _mapStateToProps = (state: HomeLocationAutoCompleteContainerProps) => {
    // cast to string if it's a message descriptor (we need a string)
    const sanitizedCurrentPlace = messageDescriptorToString(state.location.currentPlace);

    const currentPlace = state.location.isOnline
        ? messages.onlineEvents.defaultMessage
        : sanitizedCurrentPlace;
    const currentPlaceParent = state.location.currentPlaceParent;
    return {
        currentPlace,
        placeholder: state.location.isOnline
            ? messages.onlineEvents.defaultMessage
            : sanitizedCurrentPlace || messages.chooseLocation.defaultMessage,
        currentPlaceParent,
        isUsingCurrentLocation: state.location.isUsingCurrentLocation,
        isUseCurrentLocationEnabled: !state.location.locationDenied,
        isOnline: state.location.isOnline,
        isWaitingForLocation: state.location.isWaitingForLocation,
        locationSuggestions: getLocationSuggestionsMemoized(
            {
                ...state.location,
                suggestions: [],
                topSuggestions: [],
                currentPlace,
                currentPlaceParent,
            },
            !state.location.locationDenied,
        ),
        latitude: state.location.latitude,
        longitude: state.location.longitude,
        placeId: state.location.placeId,
    };
};

const _mapDispatchToProps = {
    handleLocationSuggestionChange: searchLocationSuggestionsAction,
    handleLocationSelect: locationChangeAction,
    handleUseCurrentLocation: getUserCurrentLocationAction,
};

export const HomeLocationAutocompleteContainer = connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(LocationAutocomplete);
